import { useState } from 'react';
import {
  isCurrentChange,
  isOwnChange,
  useAccountSettings,
  type SettingsChange,
} from '@/lib/account-settings';

/** Shared eligibility and mutation path for settings cards and compact receipts. */
export function useSettingsUndo(change: SettingsChange | null, toolCallId?: string) {
  const control = useAccountSettings();
  const [state, setState] = useState<'idle' | 'undoing' | 'undone' | 'failed'>('idle');
  const undoable = Boolean(
    change &&
    state !== 'undone' &&
    control &&
    isOwnChange(change, control.userId) &&
    isCurrentChange(change, control.settings),
  );
  const undo = async () => {
    if (!control || !change || !undoable || state === 'undoing') return;
    setState('undoing');
    try {
      await control.undo(change, toolCallId);
      setState('undone');
    } catch {
      setState('failed');
    }
  };
  return { state, undoable, undo };
}
